import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
//
import colors from 'theme/colors';

const { darkPanelBackground, labelPlatinum } = colors;

const ExpansionPanel = withStyles({
  root: {
    backgroundColor: darkPanelBackground,
    border: '1px solid rgba(0, 0, 0, .125)',
    color: labelPlatinum,
    fontSize: 14,
    padding: 0,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

export default ExpansionPanel;
